import { render, staticRenderFns } from "./SystemBarBtn.vue?vue&type=template&id=1eaf641b&scoped=true&"
import script from "./SystemBarBtn.vue?vue&type=script&lang=js&"
export * from "./SystemBarBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf641b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
